export const navItems = [
    { id: 'home', name: 'Home' },
    { id: 'about', name: 'About' },
    { id: 'project', name: 'Projects' },
    { id: 'certification', name: 'Certifications' },
    { id: 'contact', name: 'Contact' }

]
